import { render, staticRenderFns } from "./Gateway.vue?vue&type=template&id=27ef6596&scoped=true"
import script from "./Gateway.vue?vue&type=script&lang=js"
export * from "./Gateway.vue?vue&type=script&lang=js"
import style0 from "./Gateway.vue?vue&type=style&index=0&id=27ef6596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ef6596",
  null
  
)

export default component.exports